import { Document } from "@tudigo-monorepo/core-tudigo-api-models";

import { ContentType, type Request, type TudigoResponse } from "../api";

export type GenerateTitleHoldersCertificatesParams = {
  userId: string;
  body: {
    titleHolderIds: string[];
  };
};

export const titleHoldersEndpoints = (request: Request) => ({
  generateTitleHoldersCertificates: (
    params?: GenerateTitleHoldersCertificatesParams,
  ) => {
    return request<TudigoResponse<Document>, void>({
      method: "POST",
      path: `/api/v1/users/${params?.userId}/generate-title-certificates`,
      body: {
        title_holder_ids: params?.body.titleHolderIds,
      },
      secure: true,
      type: ContentType.Json,
    });
  },
});
